<template>
    <Dashboard
        :title="__('Create engrave', null, $page.props.profile_locale)"
    >
        <h2 class="border-b-2 text-xl border-gray-200 mb-4">{{__('Edit engrave', null, $page.props.profile_locale)}}</h2>

        <Steps>
            <StepItem
                :title="__('Select image', null, $page.props.profile_locale)"
                :progress="false"
                :active="step >= 1"
                class="w-1/2"
            >
                <template #icon>
                    <SvgIcon
                        class="mx-auto"
                        name="image"
                    />
                </template>
            </StepItem>
            <StepItem
                :title="__('Settings', null, $page.props.profile_locale)"
                :active="step >= 2"
                :width="step >= 2 ? 100 : 0"
                class="w-1/2"
            >
                <template #icon>
                    <SvgIcon
                        class="mx-auto"
                        name="pencil"
                    />
                </template>
            </StepItem>
        </Steps>

        <div class="overflow-hidden">
            <transition
                enter-active-class="transition ease-in-out duration-300 transform"
                :enter-from-class="!back ? 'opacity-0 translate-x-60' : 'opacity-0 -translate-x-60'"
                :enter-to-class="!back ? 'opacity-100 translate-x-0' : 'opacity-100 translate-x-0'"
                leave-active-class="transition ease-in-out duration-300 transform"
                :leave-from-class="!back ? 'opacity-100 translate-x-0' : 'opacity-100 translate-x-0'"
                :leave-to-class="!back ? 'opacity-0 -translate-x-60' : 'opacity-0 translate-x-60'"
                mode="out-in"
                @after-leave="back = false"
            >
                <div class="flex flex-row p-5" v-if="step == 1">
                    <div class="md:mr-3 md:mt-0 mt-3 flex flex-col">
                        <Engrave
                            :width="400"
                            :height="400"
                            class="engrave-canvas"
                            :scale="scale"
                            :image="form.base64 ? form.base64 : null"
                            placeholderSvg='<svg xmlns="http://www.w3.org/2000/svg" fill="#111827" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z" clip-rule="evenodd" /></svg>'
                            :ref="el => { engraveImage = el }"
                            @vue-avatar-editor:image-ready="onImageReady"
                        >
                        </Engrave>
                    </div>
                    <div class="w-full">
                        <input
                            type="range"
                            :min='1'
                            :max='3'
                            :step='0.1'
                            class="w-full"
                            v-model.number="scale"
                        />
                        <Button
                            padding="sm"
                            class="text-sm"
                            @click="saveClicked"
                        >
                            Dalej
                            <SvgIcon
                                class="mx-auto"
                                name="arrow-right"
                            />
                        </Button>
                        <div class="text-red-500 text-sm font-bold">{{ validMessage }}</div>
                    </div>
                </div>

                <div class="flex flex-col p-5" v-else-if="step == 2">
                    <div class="flex justify-between">
                        <Button
                            padding="sm"
                            class="text-sm"
                            @click="backClicked"
                        >
                            <SvgIcon
                                class="mx-auto"
                                name="arrow-left"
                            />
                            Wróć
                        </Button>

                        <Button
                            padding="sm"
                            class="text-sm"
                            @click="saveForm"
                        >
                            Zapisz
                            <SvgIcon
                                class="mx-auto"
                                name="save"
                            />
                        </Button>
                    </div>
                    <div class="text-red-500 text-sm font-bold">{{ validMessage }}</div>

                    <div class="mt-5">
                        <CustomSelect
                            :label="__('Select engrave', null, $page.props.profile_locale)"
                            :data="options"
                            v-if="options.length"
                            :modelValue="form.option ? form.option : null"
                            @update:modelValue="ev => {
                                if(ev){
                                    form['area'] = ev.area;
                                    form.new_area = false;
                                    form.option = ev;
                                }
                            }"
                            class="mb-3"

                        />
                        <CanvasArea
                            :image="form.base64"
                            :area="form.area"
                            @update-area="ev => {
                                form.area = ev;
                                form.new_area = true;
                                form.option = null;
                            }"
                        />
                        <div class="grid grid-cols-4 gap-3 mt-3" v-if="form.area">
                            <InputLabel
                                :label="__('Pozycja X', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.x"
                                :step='0.1'
                                :readOnly="!form.new_area"
                                v-model.number="form.area.x"
                            />
                            <InputLabel
                                :label="__('Pozycja Y', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.y"
                                :step='0.1'
                                :readOnly="!form.new_area"
                                v-model.number="form.area.y"
                            />
                            <InputLabel
                                :label="__('Pozycja W', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.w"
                                :step='0.1'
                                :readOnly="!form.new_area"
                                v-model.number="form.area.w"
                            />
                            <InputLabel
                                :label="__('Pozycja H', null, $page.props.profile_locale)"
                                type="number"
                                :min="0"
                                id="area.h"
                                :step='0.1'
                                :readOnly="!form.new_area"
                                v-model.number="form.area.h"
                            />
                            <div class="col-span-2" v-if="options.length && !form.new_area">
                                <input v-model="form.new_area" id="edit" type="checkbox">
                                <label class="ml-2" for="edit">Zmień współrzedne graweru</label>
                            </div>
                            <div class="col-span-2" v-else-if="form.new_area">
                                <InputLabel
                                    :label="__('Nazwa nowego graweru', null, $page.props.profile_locale)"
                                    v-model="form.engrave_name"
                                    id="engrave_name"
                                />
                            </div>
                        </div>

                        <div class="pt-5 mt-10 border-t border-gray-300 grid grid-cols-2 gap-3">
                            <InputLabel
                                :label="__('Title', null, $page.props.profile_locale)"
                                id="name"
                                v-model="form.name"
                                class="col-span-2"
                            />
                            <InputLabel
                                :label="__('Max characters', null, $page.props.profile_locale)"
                                type="number"
                                id="max_length"
                                :modelValue="form.option ? form.option.max_characters : form.max_length"
                                :readOnly="!form.new_area"
                                @update:modelValue="ev => {
                                    form.max_length = Number(ev)
                                }"
                            />
                            <InputLabel
                                :label="__('Max lines', null, $page.props.profile_locale)"
                                type="number"
                                id="max_lines"
                                :modelValue="form.option ? form.option.max_lines : form.max_lines"
                                :readOnly="!form.new_area"
                                @update:modelValue="ev => {
                                    form.max_lines = Number(ev)
                                }"
                            />
                            <InputLabel
                                :label="__('Text color', null, $page.props.profile_locale)"
                                type="color"
                                class="w-min"
                                id="color"
                                :size="null"
                                v-model="form.color"
                            />
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import Steps from 'STEPS/Container';
    import StepItem from 'STEPS/Item';
    import SvgIcon from 'UI/SvgIcon';
    import Button from 'UI/Button';
    import InputLabel from 'UI/InputLabel';

    import CanvasArea from 'COMP/Canvas/CanvasArea';
    import CustomSelect from 'UI/CustomSelect';

    import { VueAvatar } from 'vue-avatar-editor-improved'
    import { ref } from '@vue/reactivity';
    import { useForm, usePage } from '@inertiajs/inertia-vue3';
    import { watch } from '@vue/runtime-core';

    import {
        isObjectEmpty
    } from 'helper';

    const MIN_H = 30;

    export default {
        components: {
            Dashboard,
            Engrave : VueAvatar,
            Steps,
            StepItem,
            SvgIcon,
            Button,
            CanvasArea,
            InputLabel,
            CustomSelect,
        },

        props: {
            options: [Object, Array],
        },

        setup(props) {

            const
                engraveImage = ref(null),
                scale = ref(1),
                step = ref(1),
                back = ref(false),
                validMessage = ref(null);

            const form = useForm({
                base64: null,
                area: {},
                name: null,
                max_length: null,
                max_lines: null,

                new_area: true,
                option: null,
                engrave_name: null,
                color: '#fff',
            });
            watch(() => form.new_area, (val) =>{
                if(val) form.option = null;
            })
            const
                saveClicked = () => {
                    var img = engraveImage.value.getImageScaled();
                    form.base64 = img.toDataURL();

                    if(engraveImage.value.imageLoaded) step.value++;
                    else {
                        validMessage.value = app.__('Załaduj zdjęcie i przejdź dalej!');

                        setTimeout(() => validMessage.value = null, 4000);
                    }
                },
                backClicked = () => {
                    back.value = !back.value;
                    step.value--;
                },
                onImageReady = () => {
                    scale.value = 1
                },
                saveForm = () => {
                    if(!isObjectEmpty(form.area)) {
                        if(form.area.h < MIN_H) {
                            validMessage.value = app.__('Podaj wysokość większą bądź równą 35 !');
                            setTimeout(() => validMessage.value = null, 4000);
                        }
                    }
                    else {
                        validMessage.value = app.__('Wybierz obszar do graweru!');

                        setTimeout(() => validMessage.value = null, 4000);
                    }
                    let arr = {};
                    for (const [key, value] of Object.entries(form.data())) {
                        if(!value) {

                            if(!form.option && key != 'new_area' && key != 'option') {
                                arr[key] = app.__('validation-inline.required');
                            }
                            else {
                                if( (key == 'name' || key == 'color') && !value) arr[key] = app.__('validation-inline.required');
                            }
                        }

                        if(key == 'area') {
                            ['x', 'y', 'w', 'h'].forEach((el) => {
                                if(!value[el]) arr[key + '.' + el] = app.__('validation-inline.required');
                            });
                        }
                    }
                    if(Object.keys(arr).length > 0) usePage().props.value.errors = arr;
                    else {
                        form.post(route('dashboard.engrave.store'), {
                            preserveScroll: true,
                            onSuccess: () => {
                                form.reset();
                            },
                        })
                    }
                };

            return {
                engraveImage,
                scale,
                form,
                step,
                back,
                validMessage,

                saveClicked,
                backClicked,
                onImageReady,
                saveForm,
            }
        },
    }
</script>
<style lang="postcss">

.engrave-canvas canvas{
    @apply rounded-md;
}
</style>
